module.exports = __webpack_public_path__ + "img/appAsset-brand--mercadopago.35e01fbc.svg";